import React, { Component } from 'react'

import Subheader from '../../components/UserAgreement/Subheader'
// eslint-disable-next-line camelcase
export class UA0001 extends Component {
  render() {
    return (
      <div className="user-agrmt-template-wrapper">
        <Subheader />
        <div dangerouslySetInnerHTML={{ __html: this.props.pageContent }} />
      </div>
    )
  }
}

export default UA0001
